import React, { Component } from 'react';
import './FooterLogo.scss';

class FooterLogo extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show: true 
    }
  }

  render () {
    const cnLogo = "f-logo-container" + (this.state.show?" show":"");

    return (
      <div className={cnLogo}>
        Powered by <a data-analytics-label="DTC-footer-GSN-link" href="https://www.gsntv.com" target="_blank" rel="noopener noreferrer"><img src="images/gsntv-logo.png" alt="Game Show Network" /></a>
      </div>
    );
  }
}

export default FooterLogo;



// WEBPACK FOOTER //
// ./src/js/components/FooterLogo.js